import React from "react";
import { ShopPage } from "@onepass-app/components/ShopPage";
import { jsx as ___EmotionJSX } from "@emotion/react";

var IndexPage = function IndexPage(_ref) {
  var host = _ref.host;
  return ___EmotionJSX(ShopPage, {
    host: host
  });
};

export default IndexPage;